import { Card } from "antd";
import ListingGridItemCard from "../Components/ListingGridItemCard";
import { ListingViewItem } from "./interface";

interface Props {
	item: ListingViewItem;
	onShowDetail?: () => void;
}
const ListingCard: React.FC<Props> = ({ item, onShowDetail }) => {
	return (
		<Card
			bordered={false}
			size="small"
			className="card-listing"
		>
			<ListingGridItemCard
				value={{
					...item,
					checked: false,
				}}
				disablePickSingle={true}
				hideCheckbox={true}
				onShowDetail={onShowDetail}
			/>
		</Card>
	);
};
export default ListingCard;
